import en from 'commonAssets/i18n/en';

en.contact_admin = 'Contact Claims Administrator';

export default { en };
